import React from "react";
import { Select } from "../../../shared";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { eventFieldOptionLabel } from "../eventCatalog";
import { getPropertiesForTrigger } from "../eventProperties";
import { filterByLabelOrValue } from "../../../../utils/selectFilter";
import type { CatalogEventField } from "../types";

type Props = {
  /** Legacy mode — trigger event_type keyed into EVENT_PROPERTY_CATALOG.
   * Ignored whenever `fields` is provided. */
  eventType?: string;
  /** Catalog mode — `filterable_fields` for the selected catalog event_key.
   * Takes precedence over `eventType`, including an empty array meaning "no
   * trigger event selected yet". */
  fields?: CatalogEventField[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

/**
 * Searchable property picker for event fields.
 * In catalog mode (`fields` provided) options come from the selected event's
 * `filterable_fields`; otherwise falls back to the legacy `eventType` ->
 * EVENT_PROPERTY_CATALOG lookup.
 */
const EventPropertyField: React.FC<Props> = ({
  eventType,
  fields,
  value,
  onChange,
  placeholder = AppStrings.PAM_SEGMENTS_FIELD_PLACEHOLDER,
}) => {
  const options = fields
    ? fields.map((f) => ({
        label: eventFieldOptionLabel(f.field, f.label, f.type),
        value: f.field,
      }))
    : getPropertiesForTrigger(eventType).map((p) => ({
        label: eventFieldOptionLabel(p.value, p.label, p.type),
        value: p.value,
      }));

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      showSearch
      allowClear
      filterOption={filterByLabelOrValue}
    />
  );
};

export default EventPropertyField;
